import { isNavigationFailure, NavigationFailureType } from 'vue-router';

interface PushableRouter {
  push: (target: any) => Promise<unknown> | void;
}

// a guard redirect is an expected outcome here, not a runtime error
export async function safePush(router: PushableRouter | undefined, target: string | object): Promise<void> {
  if (!router) return;

  try {
    await router.push(target);
  } catch (error: any) {
    const expectedFailure =
      isNavigationFailure(error, NavigationFailureType.duplicated) ||
      isNavigationFailure(error, NavigationFailureType.redirected);
    if (!expectedFailure) {
      throw error;
    }
  }
}
